module.exports = __webpack_public_path__ + "img/ballantines-logo-mobile.0c58cdf1.svg";